import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// auth.ilouli.com URL 가져오기
const getAuthUrl = () => {
  const isLocal = window.location.hostname === 'localhost';
  return isLocal ? 'http://localhost:3001' : 'https://auth.ilouli.com';
};

const ProtectedRoute = ({ children, requiredTiers = null }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // auth.ilouli.com으로 리다이렉트
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `${getAuthUrl()}/login?returnUrl=${returnUrl}`;
    return null;
  }

  if (requiredTiers && !requiredTiers.includes(user.tier)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
